import queryString from "query-string";

import { uderlyConfig } from "..";

import Settings, { defaultSettings } from "../data/settings";
import { errorLog } from './Utils';
import { AdPublicRequest } from "../models/Ads/AdPublicRequest";
import { EventsRequest } from "src/models/EventsRequest";

export const getEvents = async (storeId: number, filters?: EventsRequest) => {
  const url = `${Settings.apiUrl}/events?storeId=${storeId}&${!filters ? "" : queryString.stringify(filters)}`;

  return await uderlyConfig.Axios?.get(url)
    .catch((error) => {
      console.log('error ' + error);
      return errorLog(error);
    });
}

export const getEvent = async (id: number | string) => {
  return await uderlyConfig.Axios?.get(Settings.apiUrl + "/events/" + id)
    .catch((error) => {
      console.log('error ' + error);
      return errorLog(error);
    });
}

export const getProducts = async (storeId: number) => {
  return await uderlyConfig.Axios?.get(Settings.apiUrl + "/products?storeId=" + storeId)
    .catch((error) => {
      console.log('error ' + error);
      return errorLog(error);
    });
}

export const getMediaStock = async (id: number) => {
  return await uderlyConfig.Axios?.get(Settings.apiUrl + "/mediastock/" + id)
    .catch((error) => {
      console.log('error ' + error);
      return errorLog(error);
    });
}

export const getMediaStocks = async (storeId: number, categoryId?: number) => {
  const url = `${Settings.apiUrl}/mediastock/?store_id=${storeId}&` + (categoryId ? `category_id=${categoryId}` : '');

  return await uderlyConfig.Axios?.get(url)
    .catch((error) => {
      console.log('error ' + error);
      return errorLog(error);
    });
}

export const getMedia = async (storeId: number, categoryId?: number) => {
  return await uderlyConfig.Axios?.get(Settings.apiUrl + "/mediastock?store_id=" + storeId + (categoryId ? `&category_id=${categoryId}` : ''))
    .catch((error) => {
      console.log('error ' + error);
      return errorLog(error);
    });
}

export const getDoc = async (key: string, storeId: number) => {
  return await uderlyConfig.Axios?.get(`${Settings.apiUrl}/docs/public/${key}?storeId=${storeId}`)
    .catch((error) => {
      console.log('error ' + error);
      return errorLog(error);
    });
}

export const getAds = async (request: AdPublicRequest) => {
  const apiUrl = request.useUderlyApi ? defaultSettings.apiUrl : Settings.apiUrl;
  console.log(`Getting advertisement from: ${apiUrl}`);

  return await uderlyConfig.Axios?.get(`${apiUrl}/ads/public?${queryString.stringify(request)}`)
    .catch((error) => {
      console.log('error ' + error);
      return errorLog(error);
    });
}

export const getAdTypes = async (parentId?: number, search?: string) => {
  const url = `${Settings.apiUrl}/ads/types?` + queryString.stringify({ parentId, search });

  return await uderlyConfig.Axios?.get(url)
    .catch((error) => {
      console.log('error ' + error);
      return errorLog(error);
    });
}

export const getApps = async () => {
  return await uderlyConfig.Axios?.get(`${Settings.apiUrl}/apps`)
    .catch((error) => {
      console.log('error ' + error);
      return errorLog(error);
    });
}

export const getAppTypes = async (search?: string) => {
  const url = `${Settings.apiUrl}/apps/types?` + queryString.stringify({ search });

  return await uderlyConfig.Axios?.get(url)
    .catch((error) => {
      console.log('error ' + error);
      return errorLog(error);
    });
}

export const getStore = async (storeSubdomain: string, includeStats: boolean = false) => {
  const url = `${Settings.apiUrl}/stores/bysubdomain/${storeSubdomain}?` + queryString.stringify({ includeStats });

  const response = await uderlyConfig.Axios?.get(url)
    .catch(error => {
      console.log('error ' + error);
      errorLog(error);
    });
  return response;
}

export const getStoreCountries = async (storeId: number) => {
  return await uderlyConfig.Axios?.get(`${Settings.apiUrl}/stores/${storeId}/countries`)
    .catch((error) => {
      console.log('error ' + error);
      return errorLog(error);
    });
}